import React from "react";
import PropTypes from "prop-types";

function ToggleSchedule({ activeTab, title, setActiveTab, margin }) {
  return (
    <div className="flex items-center">
      <p className=" text-lg font-normal font-ibm">{title}</p>
      <div className={`flex bg-secondary-200 rounded-2xl ml-${margin}`}>
        <p
          onClick={() => setActiveTab("now")}
          className={`py-3 px-5 rounded-2xl cursor-pointer   ${
            activeTab === "now"
              ? "bg-white shadow-outer font-ibm text-lg mb-0"
              : "font-ibm text-lg mb-0"
          } `}>
          Now
        </p>
        <p
          onClick={() => setActiveTab("schedule")}
          className={`py-3 px-5 rounded-2xl cursor-pointer ${
            activeTab === "schedule"
              ? "bg-white shadow-outer font-ibm text-lg mb-0"
              : "font-ibm text-lg mb-0"
          } `}>
          Schedule
        </p>
      </div>
    </div>
  );
}

ToggleSchedule.propTypes = {
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func,
  title: PropTypes.string,
  margin: PropTypes.any,
};

export default ToggleSchedule;
